import React from 'react';
import BaseAutoComplete from '../base-auto-complete';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { countriesWithoutAustralia } from '@nib/phi-constants';
import popularCountries from './suggestionsList';
const LABELS = {
  ARHI: DEFAULT_LABELS.COUNTRY
};
const Countries = props => {
  const {
    funnel = FUNNELS.ARHI,
    width = 20,
    label,
    options = countriesWithoutAustralia,
    suggestions = popularCountries,
    help,
    input,
    field,
    ...otherProps
  } = props;
  return React.createElement(BaseAutoComplete, {
    label: label || LABELS[funnel] || LABELS.ARHI,
    help: help,
    width: width,
    options: options,
    //suggestions={suggestions} -another possible mistake found by typescript there is no suggestions prop on baseAutoComplete component
    suggestionList: suggestions,
    keys: ['value', 'text', 'aliases'],
    field: field,
    input: input,
    funnel: funnel,
    ...otherProps
  });
};
Countries.defaultProps = {
  options: countriesWithoutAustralia,
  suggestions: popularCountries,
  width: 20
};
const CountriesWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(Countries, {
  ...props
}));
export default CountriesWithFunnel;